import React from 'react';
import { XIcon } from 'lucide-react';
import { Popup } from 'react-mapbox-gl';

const getPopupOffset = (anchor) => {
  if (anchor === 'center' || anchor === 'top' || anchor === 'bottom') {
    return [0, 0];
  }

  const horizontalOffset = anchor.includes('right') ? -12 : 12;

  if (anchor.startsWith('top')) {
    return [horizontalOffset, 12];
  }
  if (anchor.startsWith('bottom')) {
    return [horizontalOffset, -12];
  }

  return [horizontalOffset, 0];
};

const MyCityPopup = ({
  coordinates,
  anchor = 'center',
  maxHeight = 'min(520px, calc(100vh - 80px))',
  closeInfoWindow,
  closeLabel = 'Close',
  children,
}) => (
  <Popup
    coordinates={coordinates}
    offset={getPopupOffset(anchor)}
    className="infoWindow-container my-city-popup"
    anchor={anchor}
    onClick={(event) => event.stopPropagation()}
    onWheel={(event) => event.stopPropagation()}
  >
    <div
      className="overflow-y-auto overscroll-contain p-[14px] pt-0"
      style={{
        width: 'min(360px, calc(100vw - 40px))',
        maxHeight,
        WebkitOverflowScrolling: 'touch',
      }}
      onWheel={(event) => event.stopPropagation()}
    >
      <div className="sticky top-0 z-10 mr-[-12px] flex justify-end bg-white pb-[10px] pt-[10px]">
        <button
          type="button"
          className="cursor-pointer rounded p-[2px] focus:outline-none focus:ring-2 focus:ring-indigo-500"
          onClick={closeInfoWindow}
          aria-label={closeLabel}
        >
          <XIcon className="h-[16px] w-[16px] text-gray-500" />
        </button>
      </div>
      {children}
    </div>
  </Popup>
);

export default MyCityPopup;
